import { SetStateAction, useEffect, useState } from "react";
import { SearchIcon, CheckIcon } from "@heroicons/react/solid";
import { Combobox } from "@headlessui/react";
import { getParentSuggestion } from "../../../services/axios";
import { OrganizationType } from "../../../utils/types";

function classNames(...classes: (string | boolean)[]) {
  return classes.filter(Boolean).join(" ");
}

export default function ParentSearchBox({
  onSelect,
}: {
  onSelect: ({ salesforce_id }: any) => void;
}) {
  const [suggestions, setSuggestions] = useState<
    { national: string; salesforce_id: string; name: string; type: string }[]
  >([]);
  const [query, setQuery] = useState("");
  const [selected] = useState<string>("");

  useEffect(() => {
    (async () => {
      const res = await getParentSuggestion(query);

      const next =
        res?.map((item: OrganizationType) => {
          return {
            national: item.national,
            salesforce_id: item.salesforce_id,
            name: item.full_name,
            type: item.category,
          };
        }) || [];

      setSuggestions(next);
    })();
  }, [query]);

  return (
    <Combobox as="div" value={selected} onChange={onSelect} className="w-full">
      <div className="relative w-full">
        <Combobox.Input
          className="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
          onChange={(event: { target: { value: SetStateAction<string> } }) =>
            setQuery(event.target.value)
          }
          displayValue={(breed: string) => breed}
          placeholder={"Search for organization name (case sensitive)"}
        />
        <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
          <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
        </Combobox.Button>

        {suggestions.length > 0 && (
          <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            {suggestions.map((suggestion) => (
              <Combobox.Option
                key={suggestion.salesforce_id}
                value={suggestion}
                className={({ active }: { active: boolean }) =>
                  classNames(
                    "relative cursor-default select-none py-2 pl-8 pr-4",
                    active ? "bg-indigo-600 text-white" : "text-gray-900"
                  )
                }
              >
                {({
                  active,
                  selected,
                }: {
                  active: boolean;
                  selected: boolean;
                }) => (
                  <>
                    <span
                      className={classNames(
                        "block truncate",
                        selected && "font-semibold"
                      )}
                    >
                      {suggestion.name} - {suggestion.salesforce_id}
                    </span>

                    {selected && (
                      <span
                        className={classNames(
                          "absolute inset-y-0 left-0 flex items-center pl-1.5",
                          active ? "text-white" : "text-indigo-600"
                        )}
                      >
                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                      </span>
                    )}
                  </>
                )}
              </Combobox.Option>
            ))}
          </Combobox.Options>
        )}
      </div>
    </Combobox>
  );
}
